import { FacilityHomePage } from '@/pages/facility/home/component';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/facility/home')({
	component: FacilityHomePage,
});
